import React, { useEffect, useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import BaconMark from '../components/BaconMark';
import { useInstallFlyer } from '../components/InstallFlyer';

const SECTIONS = [
  { id: 'history', index: '01', title: 'History', note: 'Artists and groups you’ve queued' },
  { id: 'saved', index: '02', title: 'Saved', note: 'Bookmarks for the next side' },
  { id: 'settings', index: '03', title: 'Settings', note: 'Display, search, and tape prefs' },
  { id: 'about', index: '04', title: 'About', note: 'What Band Bacon is, and isn’t' },
];

const Profile = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { show: showInstallFlyer, canOffer } = useInstallFlyer();

  const closeProfile = useCallback(() => {
    const from = location.state?.from;
    if (typeof from === 'string' && from.startsWith('/') && from !== '/profile') {
      navigate(from);
      return;
    }
    if (location.key !== 'default') {
      navigate(-1);
      return;
    }
    navigate('/');
  }, [location.key, location.state, navigate]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === 'Escape') closeProfile();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [closeProfile]);

  return (
    <div className="profile-page">
      <header className="profile-header">
        <div className="profile-header-inner">
          <button
            type="button"
            className="profile-mark is-current"
            onClick={closeProfile}
            aria-label="Close profile"
          >
            <BaconMark />
          </button>
          <h1 className="profile-title">Profile</h1>
          <button
            type="button"
            className="deck-key close-key"
            onClick={closeProfile}
          >
            Close
          </button>
        </div>
      </header>

      <main className="profile-body">
        {canOffer && (
          <button
            type="button"
            className="profile-download"
            onClick={showInstallFlyer}
          >
            <span className="profile-download-tag">DIY</span>
            <span className="profile-download-copy">
              <span className="profile-download-title">Download this app</span>
              <span className="profile-download-note">Skip the stores. Stick it on your phone.</span>
            </span>
          </button>
        )}
        <ol className="profile-tracklist">
          {SECTIONS.map((section) => (
            <li key={section.id} className="profile-track">
              <span className="profile-track-index">{section.index}</span>
              <span className="profile-track-copy">
                <span className="profile-track-title">{section.title}</span>
                <span className="profile-track-note">{section.note}</span>
              </span>
              <span className="profile-track-soon">Soon</span>
            </li>
          ))}
        </ol>
        <div className="profile-eject">
          <button
            type="button"
            className="deck-key eject-key"
            onClick={() => navigate('/')}
          >
            Home
          </button>
        </div>
      </main>
    </div>
  );
};

export default Profile;
